<div class="position-relative h-100">
    <div class="side-bar">
      <div class="d-flex justify-content-between align-items-center pb-px-12">
        <mat-label class="fs-20 fw-700">{{ data.firstName }}  {{data.lastName}}</mat-label>
        <img (click)="dialogRef.close()" src="/assets/icons/close-modal-primary.svg"
             class="cursor-pointer"/>
      </div>
  
      <div class="mt-px-32">
        <app-text-separator text="Détails utilisateur" [innerClass]="'my-px-24'"></app-text-separator>
        <div class="mb-px-16">
          <div class="fw-3 fs-13">Title</div>
          <div class="fs-16 fw-4">{{ data.title || 'N/A'}}</div>
        </div>
  
        <div class="mb-px-16">
          <div class="fw-3 fs-13"> Prénom</div>
          <div class="fs-16 fw-4">{{ data.firstName || 'N/A'}}</div>
        </div>
  
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Nom</div>
          <div class="fs-16 fw-4">{{ data.lastName || 'N/A'}}</div>
  
          <div class="fw-3 fs-13 mt-px-16">Fonction</div>
          <div class="fs-16 fw-4">{{ data.fonction || 'N/A'}}</div>
        </div>
  
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Email</div>
          <div class="fs-16 fw-4">{{ data.mail || 'N/A'}}</div>
  
          <div class="fw-3 fs-13 mt-px-16">Numéro de Télèphone</div>
          <div class="fs-16 fw-4">{{ data.numTel || 'N/A'}}</div>
        </div>
        </div>
  
    </div>
  </div>
  